<div class="col-md">
  <div [innerHTML]="textHtmlModal" *ngIf="textHtmlModal"></div>
  <label for="justificativa" class="col-12 mb-1">{{placeholder}}</label>
  <textarea nz-input [(ngModel)]="text" [nzAutosize]="{ minRows: 5, maxRows: 12 }"></textarea>
  <control-error [text]="'Campo Obrigatório'" *ngIf="showError"></control-error>
</div>